import React from 'react';
import SideMenuRightContainer from '../side-menu-right-container/side-menu-right-container';
import { Flex, Text } from '../../common/common-components.styled';
import { StyledLink } from '../onboarding-component/choose-entity/choose-entity.styled';

const ErrorScreen = () => {
  return (
    <SideMenuRightContainer>
      <Flex direction='column' align='center'>
        <Flex maxWidth='700px'>
          <img src='/assets/images/error_screen_img.svg' alt='error_screen_img' />
        </Flex>
        <Text color='grey800' bottom='20' size='16' bold>
          Systemupdate - wir sind gleich wieder da.
        </Text>
        <Text color='grey800' bottom='10'>
          Bei weiteren Fragen senden Sie uns gerne eine Email an{' '}
          <StyledLink color='grey800' href='mailto:fuhrpark@mobexo.de'>
            fuhrpark@mobexo.de
          </StyledLink>
          .
        </Text>
        <Text color='grey800'>
          Keine Sorge – wir kümmern uns bereits darum, dass alles schnell wieder für Sie verfügbar ist. Bitte versuchen
          Sie es in Kürze erneut. Vielen Dank für Ihr Verständnis und Ihre Geduld!
        </Text>
      </Flex>
    </SideMenuRightContainer>
  );
};

export default ErrorScreen;
